import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { untouch, change, formValueSelector } from 'redux-form';

export default function (WrappedComponent) {
    class subcategoryFieldUpdater extends React.Component {
        static propTypes = {
            acceptedSubcategories: PropTypes.array,
            filteredSubcategoriesList: PropTypes.object,
            subcategoryFormValues: PropTypes.object,
            updateFormFieldValue: PropTypes.func.isRequired,
        }

        componentDidMount() {
            this.validateValues();
        }

        componentDidUpdate() {
            this.validateValues();
        }

        validateValues = () => {
            const {
                acceptedSubcategories,
                subcategoryFormValues,
            } = this.props;

            if (!acceptedSubcategories.length) {
                return;
            }

            const diff = utils.diffArrays(subcategoryFormValues.value, acceptedSubcategories);

            if (!utils.isEmpty(diff)) {
                const newValues = Object.assign({}, subcategoryFormValues, {
                    value: acceptedSubcategories,
                });

                this.updateFormFieldValue(newValues);
            }
        }

        updateFormFieldValue = (value) => {
            const {
                updateFormFieldValue,
            } = this.props;

            let form = 'filterForm';
            let field = 'subcategory_id';

            return updateFormFieldValue(form, field, value);
        }

        render() {
            const {
                filteredSubcategoriesList,
            } = this.props;

            return <WrappedComponent
                { ...this.props }
                filteredSubcategoriesList={ filteredSubcategoriesList }
            />;
        }
    }

    // Decorate with connect to read form values
    const selector = formValueSelector('filterForm');

    const subcategoryFormValues = (state) => {
        const formSubcategories = selector(state, 'subcategory_id');

        if (!utils.has(formSubcategories, 'value')) {
            return [];
        }

        return formSubcategories.value;
    };

    const categoryFormValues = (state) => {
        const formCategories = selector(state, 'category_id');

        if (!utils.has(formCategories, 'value')) {
            return [];
        }

        return formCategories.value;
    };

    const categoriesSelector = (state) => {
        return state.categories.data;
    };

    const getGroupedSubcategories = createSelector(
        categoriesSelector,
        (categories) => {
            const result = {};

            if (utils.isEmpty(categories)) {
                return result;
            }

            utils.each(categories, function (category) {
                const { subcategories } = category;

                // If there are no subcategories we will not show this category.
                if (utils.isEmpty(subcategories)) {
                    return;
                }

                let items = {
                    id: category.id,
                    name: category.name,
                    values: category.subcategories.map((item) => {
                        return {
                            id: item.id,
                            name: item.name,
                        };
                    }),
                };

                result[category.id] = items;
            });

            return result;
        },
    );

    const getFilteredSubcategories = createSelector(
        getGroupedSubcategories,
        categoryFormValues,
        (groupedSubcategories, selectedCategories) => {
            if (!selectedCategories.length) {
                return groupedSubcategories;
            }

            if (!selectedCategories || !selectedCategories.length) {
                return groupedSubcategories;
            }

            let list = {};

            utils.each(selectedCategories, (categoryId) => {
                if (groupedSubcategories.hasOwnProperty(categoryId)) {
                    list[categoryId] = groupedSubcategories[categoryId];
                }
            });

            return list;
        },
    );

    const getAcceptedSubcategories = createSelector(
        getGroupedSubcategories,
        categoryFormValues,
        subcategoryFormValues,
        (groupedSubcategories, selectedCategories, selectedSubcategories) => {
            let newSubcategories = [];

            if (!utils.isEmpty(groupedSubcategories) && selectedSubcategories.length) {
                const availableSubcategories = selectedCategories.map((categoryId) => {
                    return groupedSubcategories[categoryId].values;
                }).flat();

                utils.each(selectedSubcategories, (selectSubcategory) => {
                    const found = !!availableSubcategories.find((item) => {
                        return item.id === selectSubcategory;
                    });

                    if (found) {
                        newSubcategories.push(selectSubcategory);
                    }
                });
            }

            return newSubcategories;
        },
    );

    const mapStateToProps = (state) => {
        return {
            acceptedSubcategories: getAcceptedSubcategories(state),
            filteredSubcategoriesList: getFilteredSubcategories(state),
            subcategoryFormValues: selector(state, 'subcategory_id'),
        };
    };

    const mapDispatchToProps = (dispatch) => {
        return {
            updateFormFieldValue: (form, field, value) => {
                dispatch(change(form, field, value));
                dispatch(untouch(form, field));
            },
        };
    };

    return connect(
        mapStateToProps,
        mapDispatchToProps,
    )(subcategoryFieldUpdater);
}



// WEBPACK FOOTER //
// ./src/components/hoc/subcategoryFieldUpdater.js